import {peakAlert} from "../../../PeakDialog.js";
import {ZIDX, ZIDXPage} from "../../../standalone/standaloneLibrary.js";
import jQuery from "jquery";
const $: JQueryStatic = jQuery;

export class ZIDXAccountSavedSearchEdit implements ZIDXPage{
    zidx:ZIDX;
    constructor(zidx:ZIDX) {
        this.zidx = zidx;
    }
    getPageClass(){
        return "zidxAccountSavedSearchEditContainer";
    }
    render(){
        // console.log("saved search edit");
        let self=this;
        this.zidx.zidxBase.resetForNavigation();
        this.zidx.zidxBase.init(false, true, false, false);
        $("#searchSave", self.zidx.peakidxShadowRoot).on("click", (e: JQuery.ClickEvent) => {
            e.preventDefault();
            let saveButton = $("#searchSave", self.zidx.peakidxShadowRoot);
            if (saveButton.prop("disabled")) {
                return;
            }
            self.zidx.zidxBase.checkForSearchFormChanges(false, true);
            let data = {
                "saved_search_json_criteria": self.zidx.zidxBase.json,
                "redirectURL": $("input[name=\"redirectURL\"]", self.zidx.peakidxShadowRoot).val(),
                "saved_search_email": String($("input[name=\"saved_search_email\"]", self.zidx.peakidxShadowRoot).val() ?? "").trim(),
                "saved_search_id": $("input[name=\"saved_search_id\"]", self.zidx.peakidxShadowRoot).val(),
                "saved_search_format": $("input[name=\"saved_search_format\"]:checked", self.zidx.peakidxShadowRoot).val(),
                "saved_search_frequency": $("input[name=\"saved_search_frequency\"]:checked", self.zidx.peakidxShadowRoot).val()
            };
            if(data.saved_search_email === ""){
                peakAlert("Please enter a email for the search");
                return;
            }

            let obj = {
                id: "ajaxSaveSearch",
                method: "post",
                postObj: data,
                ignoreOldRequests: false,
                callback: function (r1: string) {
                    let r;
                    try {
                        r = JSON.parse(r1);
                    } catch (err) {
                        saveButton.prop("disabled", false);
                        peakAlert("Failed to save the search. Please try again.");
                        return;
                    }
                    if (r.success) {
                        self.zidx.redirectFormResponse(r, "")
                    } else {
                        saveButton.prop("disabled", false);
                        peakAlert(r.errorMessage);
                    }
                },
                errorCallback: function () {
                    saveButton.prop("disabled", false);
                    peakAlert("Failed to save the search. Please try again.");
                },
                url: this.zidx.getPrefixURL("/account/saved-searches/save")
            };
            saveButton.prop("disabled", true);
            this.zidx.ajaxRequest(obj);
        });

    }
}